// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__TV2HX","horizontal":"list_horizontal__mQjpM","vertical":"list_vertical__33RRL","container":"list_container__jnSTA"};